import clsx from 'clsx'
import React from 'react'

import {classes} from './styles'

type Props = {
  fullHeight?: boolean
  scrollable?: boolean
  className?: string
}

const DrawerSection: React.FC<React.PropsWithChildren<Props>> = ({fullHeight, scrollable, children, className}) => {
  return (
    <div
      className={clsx(classes.section, fullHeight && classes.fullHeight, scrollable && classes.scrollable, className)}
    >
      {children}
    </div>
  )
}

export default DrawerSection
